// extracted by mini-css-extract-plugin
export var logo = "_k8-2";
export var logoWrapper = "_k8-1";
export var strip = "_k8-0";